import { defineMessages } from "react-intl";

const messages = defineMessages({
    correct: {
        id: "task.result.correct",
    },
    incorrect: {
        id: "task.result.incorrect",
    },
    incorrectNote: {
        id: "task.result.incorrectNote",
    },
    willBeDisplayed: {
        id: "task.result.placeholder",
    },
    timeup: {
        id: "task.result.timeup",
    },
    slow: {
        id: "task.result.slow",
    },
    fast: {
        id: "task.result.fast",
    },
    next: {
        id: "general.next",
    },
});

export default messages;
